import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SpesaLegale } from "../../../models/tipologiche/spesa-legale";
import { SpeseLegaliFormUpdateComponent } from "./spese-legali-form-update.component";

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [spese-legali-mod-update]',
  templateUrl: 'spese-legali-mod-update.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class SpeseLegaliModUpdate {
  @Input() tipoPetitium: string;
  @Output() onReturn: EventEmitter<SpesaLegale> = new EventEmitter<SpesaLegale>();
  @ViewChild('formSpesaLegaleUpdate') modaleSpesaLegaleUpdate: SpeseLegaliFormUpdateComponent;

  inizializza(spesaLegale: SpesaLegale, tipoPetitium: string) {
      this.modaleSpesaLegaleUpdate.inizializza(spesaLegale, tipoPetitium);
      openModal('modalmodspesa');
  }

  createForm(tipoPetitium) {
      this.modaleSpesaLegaleUpdate.createForm(tipoPetitium);
  }

  manageModal(event) {
      closeModal('modalmodspesa');
      this.onReturn.emit(event);
  }
}
